<template>
  <div class="main-container">
    <div id="chart-container"></div>
    <div
      v-if="showBtn==false"
      class="d-flex align-center justify-center"
    >
      <br><br><br><br><br><br>
       <!-- No Chart -->
       <FullLoading :loading="!showBtn" style="margin-top: 25vh;"/>
    </div>
    <v-container fluid>
      <v-layout column class="fab-container">
        <v-card
          v-show="!loadingOrgchart"
          outlined
          width="auto"
          height="30"
          :style="`border: 1px solid #C7C7C7; position: fixed; top: ${scrollPosition>90? 117:$vuetify.breakpoint.name == 'xs'? 245-scrollPosition:235-scrollPosition}px; right: 22px;`"
        >
          <v-btn
            id="zoomOut"
            icon
            tile
            small
            color="#999999"
            v-show="!loading"
            :dark="!percent==25"
            :disabled="percent==25"
            @click="zoomOut"
          >
            <v-icon dark>
              mdi-minus
            </v-icon>
          </v-btn>
          <v-btn
          class="ma-0 pa-0"
            tile
            small
            text
            disabled
            color="#999999"
            v-show="!loading"
          >
            {{ percent }}%
          </v-btn>
          <v-btn
            id="zoomIn"
            icon
            tile
            small
            color="#999999"
            v-show="!loading"
            :dark="!percent==175"
            :disabled="percent==175"
            @click="zoomIn"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
        </v-card>
        <v-row>
          <v-btn
            id="btn-export"
            class="mx-2 mr-10 mb-10 white--text"
            :style="`margin-top: ${scrollPosition>90? 85:$vuetify.breakpoint.name == 'xs'? 210-scrollPosition:200-scrollPosition}px;`"
            fixed
            color="#2BA197"
            elevation="0"
            @click="saveChartToPNG"
            v-show="showBtn"
            :disabled="!canExport"
          >
          <img width="16" height="16" class="mr-2 mt-1" src="@/assets/icons/tray-arrow-down.png"/>
          ดาวน์โหลด
          </v-btn>
        </v-row>
        <!-- <v-row>
          <v-btn
            id="btn-export"
            class="mx-2 mr-10 mb-10"
            :style="`margin-top: ${scrollPosition>90? 100:$vuetify.breakpoint.name == 'xs'? 210-scrollPosition:220-scrollPosition}px;`"
            dark
            fixed
            outlined
            color="success"
            @click="saveChartToPNG"
            v-show="showBtn"
            :disabled="!canExport"
          >
          Export
          </v-btn>
        </v-row>
        <v-row>
          <v-btn
            id="zoomIn"
            class="mx-2"
            :style="`margin-top: ${scrollPosition>90? 108:$vuetify.breakpoint.name == 'xs'? 218-scrollPosition:228-scrollPosition}px; right: 14px;`"
            fab
            outlined
            dark
            small
            fixed
            top
            color="primary"
            v-show="showBtn"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn
            id="zoomOut"
            class="mx-2"
            :style="`margin-top: ${scrollPosition>90? 152:$vuetify.breakpoint.name == 'xs'? 262-scrollPosition:272-scrollPosition}px; right: 14px;`"
            fab
            outlined
            dark
            small
            fixed
            top
            right
            floating
            color="primary"
            v-show="showBtn"
          >
            <v-icon dark>
              mdi-minus
            </v-icon>
          </v-btn>
        </v-row> -->
    </v-layout>
    </v-container>
    <OverlayLoading :loading="loading"/>
    <v-dialog
      persistent
      v-model="dialog"
      width="100%"
      height="100%"
    >
      <!-- <OrgchartPanal :resource="this.dialogResource"/> -->
    </v-dialog>
  </div>
</template>
<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/es6-promise/4.1.1/es6-promise.auto.min.js"></script>
<script type="text/javascript" src="js/jquery.min.js"></script>
<script>
import $ from 'jquery'
// import OrgchartPanal from './_orgchartPanal.vue'
import { EventBus } from '@/EventBus'
import FullLoading from '../_template/FullLoading.vue'
import OverlayLoading from '../_template/OverlayLoading.vue'
import { hostUrl, fetchViewOrgchart, generateBase64Image } from '@/API/API'

// const thaiCut = require('thai-cut-slim')
const axios = require('axios')
const html2canvas = require('html2canvas')
const FileSaver = require('file-saver')
const wrap = require('word-wrap')
window.html2canvas = html2canvas

export default {
  props: {
    companyUID: String,
    offsetx: Number,
    offsety: Number
  },
  components: {
    FullLoading,
    OverlayLoading
  },
  name: 'tree',
  data () {
    return {
      scrollPosition: 0,
      offset: 128,
      offsetTop: 0,
      dialog: false,
      showBtn: false,
      zoomval: 0,
      img64Array: [],
      zoomCount: 0,
      canExport: true,
      loading: false,
      loadingOrgchart: false,
      orgchartData: [],
      noData: false,
      percent: 100,
      colorSet: {
        'สายงาน': '#3D5D85',
        'ฝ่ายงาน': '#5CC2EF',
        'ส่วนงาน': '#6FB540',
        'หน่วยงาน': '#F2BE47;',
        'กลุ่มงาน': '#F37959',
      },
      oc: null,
      zoom: 1
    }
  },
  watched: {
    companyUID: function(newVal, oldVal) { // watch it
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    },
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll)
    var self = this
    EventBus.$on('hideNavbarDone', function () {
       setTimeout( () => {
        self.offset = 0
      }, 2000)
    })
  },
  computed: {},
  created () {
    this.getChartData()
        // await self.createChart(result)
    // this.showBtn = false
    // let resource = await this.getChartData()
    // if (resource!==undefined) {
    //   // console.log(resource)
    //   this.createChart(resource)
    //   this.showBtn = true
    // } else {
    //   this.showBtn = false
    // }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    async getChartData () {
      let result = undefined
      let self = this
      self.orgchartData = []
      self.showBtn = false
      self.loadingOrgchart = true
      self.noData = false
      let obj = { companyId: this.companyUID }

      try {
        const res = await fetchViewOrgchart(self.$store.state.token, obj)
        if (res.success) {
          result = res.result
          self.orgchartData = result
          // console.log(JSON.stringify(self.orgchartData))
          await this.modifyKeys(result)
          self.showBtn = true
        } else {
          result = undefined
          self.showBtn = false
          self.noData = true
        }
      } catch (error) {
        result = undefined
        console.log(error)
      } finally {
        await this.createChart(this.orgchartData)
        self.loadingOrgchart = false
      }
    },
    async getBase64Profile (filePath, email) {
      let result = [{'base64':''}]
      let self = this
      let obj = {
        "listPart": [
          {
            "img": filePath,
            "email": email
          }
        ]
      }
      self.loadingOrgchart = true

      try {
        const res = await generateBase64Image(self.$store.state.token, obj)
        if (res.success) {
          result = res.result[0].base64
        } else result = ''
      } catch (error) {
        // console.log(error)
        result = ''
      } finally {
        self.loadingOrgchart = false
      }
      // console.log(result)
      return result
    },
    async modifyKeys(obj){
      for (var key in obj) {
        if (obj[key]!==null) {
          if (key == 'base64' && obj['base64']!=='') {
            // obj['img'] = 'uploads/62149.jpg'
            // let img64 = await this.getBase64Profile(obj['img'], obj['email'])
            // obj['img64'] = 'data:image/jpeg;base64,' + img64.toString()
            obj['img64'] = 'data:image/jpeg;base64,' + obj['base64'].toString()
          }
          if (key == 'title' && obj['title']!==null) {
            var str = obj['title'].trim()
          }
          if (key == 'titleArray' && obj['titleArray']!==[]) {
            let str = ''
            obj['titleArray'].forEach((e,i) => {
              str += i!==0? '<br>' + e : e
            })
            obj['title'] = str
          }
          if (key == 'name' && obj['name']!==null) {
            obj['name'] = wrap(obj['name'].trim(), {width: 30, newline: '<br>'})
          }
          if(typeof obj[key] == 'object'){
            await this.modifyKeys(obj[key])
          }
        }
      }
    },
    nodeTemplate (datasource) {
      {
        if (datasource.img64 === 'data:image/jpeg;base64,') {
          datasource.img64 = '/img/icons/noname.jpg'
        }
        let cssProfileImage = `
        width: 65.4px;
        height: 65.4px;
        max-width: 65.4px !important;
        object-fit: cover;
        border-radius: 50%;
        border : solid;
        border-color: #D3D3D3;
        border-width: thin;
        object-fit: contain;
        `
        let cssNode = `
        text-align: center;
        justify-content: center;
        align-items: center;
        padding: 8px 8px 12px;
        width: 280px;
        background: #FFFFFF;
        border: 2px solid ${datasource.nodePreView? this.colorSet[datasource.type]:'#C7C7C7'};
        box-sizing: border-box;
        border-radius: 4px;
        border-top: 6px solid ${this.colorSet[datasource.type]};
        `
        let imagUI = datasource.img==undefined? ``:`<img src="${datasource.img64}" style="${cssProfileImage}"/>`

        let partTitle = `
          <p style="
            margin-top: 5px;
            margin-bottom: 5px;
            margin-left: 0;
            margin-right: 0;
            font-family: Sarabun;
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            color: #333333;
          ">${datasource.title||''}</p>
        `
        let partName = `
          <p style="
            margin-top: 10px;
            margin-bottom: 5px;
            margin-left: 0;
            margin-right: 0;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            color: #333333;
          ">${datasource.name||''}</p>
        `
        let partPostion = `
          <p style="
            margin-top: 10px;
            margin-bottom: 5px;
            margin-left: 0;
            margin-right: 0;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            color: #757575;
          ">${datasource.name? datasource.position||'':''}</p>
        `

        return `
        <div style="
        ${cssNode}
        ">
          <div class="custom-user">
            ${imagUI}
            ${datasource.title? partTitle:''}
            ${datasource.name? partName:''}
            ${datasource.name? partPostion:''}
          </div>
        </div>
        `
        // word-wrap: break-word;
      }
    },
    async createChart (data) {
      // console.log('createChart')
      var oc1 = $('#chart-container').empty()
      var oc2 = $('.orgchart').empty()
      var self = this
      self.oc = $('#chart-container').orgchart({
        chartClass: 'chart-container',
        data : data,
        nodeTitle: 'name',
        // nodeContent: 'title',
        // nodeId: 'id',
        // parentNodeSymbol: 'pid',
        verticalLevel: 8,
        // visibleLevel: 6,
        // 'direction': 'b2t',
        // 'direction': 'l2r',
        // 'depth': 1,
        // 'verticalDepth': 3,
        pan: true,
        zoom: false,
        // zoominLimit: 3,
        // zoomoutLimit: 1,
        draggable: false,
        parentNodeSymbol: 'fa-users',
        // 'toggleSiblingsResp': true,
        // toggleSiblingsResp: false,
        nodeTemplate: this.nodeTemplate,
        exportButton: false,
        exportFilename: 'orgchart',
        exportFileextension: 'png',
        // 'createNode': function($node, data) {
        //   $node.on('click', function(event) {
        //     if (!$(event.target).is('.edge, .toggleBtn')) {
        //       var $this = $(this);
        //       var $chart = $this.closest('.orgchart');
        //       var newX = window.parseInt(($chart.outerWidth(true)/2) - ($this.offset().left - $chart.offset().left) - ($this.outerWidth(true)/2));
        //       var newY = window.parseInt(($chart.outerHeight(true)/2) - ($this.offset().top - $chart.offset().top) - ($this.outerHeight(true)/2));
        //       $chart.css('transform', 'matrix(1, 0, 0, 1, ' + newX + ', ' + newY + ')');
        //     }
        //   });
        // },
        'initCompleted': function(){
          setTimeout( function(){
            // center the chart to container
            var $container = $('#chart-container');
            var $chart = $('.orgchart');
            $chart.addClass('noncollapsable'); // deactivate
            // $chart.css('transform', "scale(1,1)");
            self.zoom = 1
            var zoomval = 0.6295000000000002
            var zoomCount = 0;
            self.percent = 100
            var currentZoom = zoomval
            var difter = (Math.floor($chart.height()/2000))*500
            var offsetTop = $chart.height() <= 800 ? 0 :
                            $chart.height() > 5000 ? ($chart.height()-$chart.offset().top)/($chart.height()/difter) :
                            $chart.height() > 2000 ? ($chart.height()-$chart.offset().top)/($chart.height()/difter) : $chart.offset().top
            self.offsetTop = offsetTop
            $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
            // zoom buttons
            $('#zoomIn').on('click', function () {
              if (zoomCount <= 2) {
                self.percent+=25
                zoomCount++
                zoomval = currentZoom += 0.1235;
                offsetTop-=(($chart[0].scrollHeight - $chart.height())*Math.abs(zoomCount))
                self.offsetTop = offsetTop
                $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
              }
            });
            $('#zoomOut').on('click', function () {
              if (zoomCount >= -3) {
                self.percent-=25
                zoomCount--
                zoomval = currentZoom -= 0.1235;
                if (zoomval.toFixed(1) < 1 ) {
                offsetTop+=(($chart[0].scrollHeight - $chart.height())*Math.abs(zoomCount))
                self.offsetTop = offsetTop
                $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
                }
              }
            });
          }  , 0 );
        },
      });
    },
    zoomIn () {
      // if (this.zoomCount <= 2) {
      //   this.percent += 25
      //   this.zoomCount++
      //   var $chart = $('.orgchart')
      //   this.oc.setChartScale($chart, this.zoom+=0.25)
      //   console.log('zoom in')
      // }
    },
    zoomOut () {
      // if (this.zoomCount >= -3) {
      //   this.percent -= 25
      //   this.zoomCount--
      //   var $chart = $('.orgchart')
      //   this.oc.setChartScale($chart, this.zoom-=0.25)
      //   console.log('zoom out')
      // }
    },
    async calculateOffset () {
    },
    async hideNavbar () {
      EventBus.$emit('hideNavbar')
    },
    async resizeBeforeExport () {
      let $container = $('#chart-container');
      let $chart = $('.orgchart');
      let div = $chart.css('transform');
      let zoomval = 0.4 - (0.039*($chart.width()/$container.width()))
      var difter = (Math.floor($chart.height()/2000))*540
      var offsetTop = $chart.height() <= 800 ? 0 :
                      $chart.height() > 5000 ? difter + Math.abs($chart.position().top) + $chart.offset().top :
                      $chart.height() > 2000 ? difter + Math.abs($chart.position().top) + $chart.offset().top : $chart.offset().top
      $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
      // $chart.css('margin-top', `-${$chart.position().top}px`)
      // $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)-this.offsetx+this.offset}, ${(-($container[0].scrollHeight - $container.height())/2)-this.offsety}) scale(${zoomval}, ${zoomval})`)
    },
    async saveChartToPNG () {
      var self = this
      this.canExport = false
      this.loading = true
      self.oc.init()
      await this.oc.export('oc', 'png')
      setTimeout( () => {
        this.canExport = true
        this.loading = false
      }, 2000)
      // await this.hideNavbar()
      // await this.resizeBeforeExport()
      // setTimeout( () => {
      //   this.resizeBeforeExport()
      // }, 1000)
      // let element = document.querySelector("#chart-container")
      // let zoomval_origin = 0.5
      // let $container = $('#chart-container');
      // let $chart = $('.orgchart');
      // setTimeout( () => {
      //     html2canvas(
      //     element,
      //     {
      //       // logging: true,
      //       allowTaint: false,
      //       useCORS: false,
      //       foreignObjectRendering: false,
      //       scale: 6,
      //       scrollY: 20,
      //       // height: $chart.height(),
      //       // width: $container.width(),
      //       height: $chart.height() > 2000? ($chart.height()-self.offsetTop)/2:$chart.height()-self.offsetTop,
      //       // windowWidth: 2000,
      //       // windowHeight: 200
      //     }
      //     ).then(canvas => {
      //       canvas.toBlob(function(blob) {
      //         FileSaver.saveAs(blob, "orgchart.png");
      //         self.canExport = true
      //         self.loading = false
      //         $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-self.offsetTop}) scale(${zoomval_origin}, ${zoomval_origin})`)
      //         // $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)-self.offsetx}, ${(-($container[0].scrollHeight - $container.height())/2)-self.offsety}) scale(${zoomval_origin}, ${zoomval_origin})`)
      //     })
      //   })
      // }, 2000)
    }
  }
}
</script>

<style lang="scss">

$blue-dk: #002a50;
$blue: #22659c;

@mixin shadow($level: 1) {
  @if $level == 1 {
    box-shadow: 0 1px 3px rgba(black, 0.12), 0 1px 2px rgba(black, 0.24);
  } @else if $level == 2 {
    box-shadow: 0 3px 6px rgba(black, 0.16), 0 3px 6px rgba(black, 0.23);
  } @else if $level == 3 {
    box-shadow: 0 10px 20px rgba(black, 0.19), 0 6px 6px rgba(black, 0.23);
  } @else if $level == 4 {
    box-shadow: 0 14px 28px rgba(black, 0.25), 0 10px 10px rgba(black, 0.22);
  } @else if $level == 5 {
    box-shadow: 0 19px 38px rgba(black, 0.3), 0 15px 12px rgba(black, 0.22);
  }
}

#zoomIn {
  // padding: 50px;
  // margin-right: 100px;
  // right: 135px;
}
#zoomOut {
  // padding: 50px;
  // margin-right: 100px;
  // right: 90px;
}

#btn-export{
  right: -18px;
  top: -18px;
}

.fab-container {
//   position: fixed;
//   bottom: 0;
//   right: 0;
}

.main-container {
  // top: 5%;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.chart-custom {
  // position: relative;
  // display: inline-block;
  // width: calc(100%);
  // overflow: scroll;
}

.chart-container {
  // padding: -1000px;
  // margin: 0px;
  // position: relative;
  // display: inline-block;
  // height: 600px;
  // height: calc(100% - 240px);
  // width: calc(100%);
  // border: 2px dashed #aaa;
  // border-radius: 5px;
  // overflow: auto;
  // text-align: center;
  // transform: scale(0.8);
  // transform: scale(0.24);
  // transform-origin: 0 0;
}

.custom-name {
  font-size: 18px;
  margin: 5px 0 0;
  font-weight: 100;
}
.custom-role {
  font-size: 20px;
  font-weight: 80;
  margin-bottom: 10px;
  // margin-top: 5px;
}
.custom-manager {
  font-size: 12px;
  color: #b21e04;
}

.border-chart {
  // text-decoration: none;
  // color: #666;
  font-family: arial, verdana, tahoma;
  display: inline-block;
  padding: 10px 10px;
  // transition: all 0.5s;
  // background: #fff;
  min-width: 220px;
  border-radius: 6px;
  // display:flex;
  // align-items:center;
  // justify-content:center;
  // flex-direction:column;
  box-shadow: 0 1px 3px rgba(black, 0.12), 0 1px 2px rgba(black, 0.24);
}

.img-border-chart {
  width: 5vw;
  height: 5vw;
  max-width: 5vw !important;
  border-radius: 50%;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 0 0 5px #aaa;
}

.chart-menu {
    border-width: 10px !important;
    border-color: #aeaeae !important;
    border: 1px solid #aeaeae !important
  }
  [data-item] {
    border-width: 0px !important;
    padding: 10px !important;
  }
  [data-tlbr] {
    margin: 20px !important;
  }
  [data-tlbr="layout"] {
      transform: rotate(0deg) translateX(0px) translateY(0px) !important;
  }
  .shadow {
    -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
    filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
  }
  /* [node-id] rect {
    fill: #CAE3CC;
  } */
  text {
  font-family: 'Sarabun', sans-serif !important;
  /* font-weight: bold; */
  font-size: 28px;
}

.org-chart {
  display: flex;
  justify-content: center;
  ul {
    padding-top: 20px;
    position: relative;
    transition: all 0.5s;
    ul::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      border-left: 1px solid #ccc;
      /* // width: 0;
      //height: 20px; */
    }
  }
  li {
    float: left;
    text-align: center;
    list-style-type: none;
    position: relative;
    padding: 10px 10px 10px 10px;
    transition: all 0.5s;
  }
}

.orgchart ~ .mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.orgchart ~ .mask .spinner {
  position: absolute;
  top: calc(50% - 54px);
  left: calc(50% - 54px);
  color: rgba(255, 255, 255, 0.8);
  font-size: 108px;
}
.orgchart .node {
  transition: transform 0.3s, opacity 0.3s;
}
.orgchart .slide-down {
  opacity: 0;
  transform: translateY(40px);
}
.orgchart.l2r .node.slide-down,
.orgchart.r2l .node.slide-down {
  transform: translateY(130px);
}
.orgchart .slide-up {
  opacity: 0;
  transform: translateY(-40px);
}
.orgchart.l2r .node.slide-up,
.orgchart.r2l .node.slide-up {
  transform: translateY(-130px);
}
.orgchart .slide-right {
  opacity: 0;
  transform: translateX(130px);
}
.orgchart.l2r .node.slide-right,
.orgchart.r2l .node.slide-right {
  transform: translateX(40px);
}
.orgchart .slide-left {
  opacity: 0;
  transform: translateX(-130px);
}
.orgchart.l2r .node.slide-left,
.orgchart.r2l .node.slide-left {
  transform: translateX(-40px);
}

.orgchart .hidden,
.orgchart ~ .hidden {
  display: none;
}
.orgchart.b2t {
  transform: rotate(180deg);
}
.orgchart.l2r {
  position: absolute;
  transform: rotate(-90deg) rotateY(180deg);
  transform-origin: left top;
}
.orgchart .verticalNodes ul {
  list-style: none;
  margin: 0;
  padding-left: 18px;
  text-align: left;
}
.orgchart .verticalNodes ul:first-child {
  margin-top: 2px;
}
.orgchart .verticalNodes > td::before {
  content: "";
  border: 1px solid #999999;
}
.orgchart .verticalNodes > td > ul > li:first-child::before {
  box-sizing: border-box;
  top: -4px;
  height: 30px;
  width: calc(50% - 2px);
  border-width: 2px 0 0 2px;
}
.orgchart .verticalNodes ul > li {
  position: relative;
}
.orgchart .verticalNodes ul > li::before,
.orgchart .verticalNodes ul > li::after {
  box-sizing: border-box;
  content: "";
  position: absolute;
  left: -6px;
  border-color: #999999;
  border-style: solid;
  border-width: 0 0 2px 2px;
}
.orgchart .verticalNodes ul > li::before {
  top: -4px;
  height: 30px;
  width: 11px;
}
.orgchart .verticalNodes ul > li::after {
  top: 1px;
  height: 100%;
}
.orgchart .verticalNodes ul > li:first-child::after {
  box-sizing: border-box;
  top: 24px;
  width: 11px;
  border-width: 2px 0 0 2px;
}
.orgchart .verticalNodes ul > li:last-child::after {
  box-sizing: border-box;
  border-width: 2px 0 0;
}
.orgchart.r2l {
  position: absolute;
  transform: rotate(90deg);
  transform-origin: left top;
}
.orgchart > .spinner {
  font-size: 100px;
  margin-top: 30px;
  color: rgba(68, 157, 68, 0.8);
}
.orgchart table {
  border-spacing: 0;
  border-collapse: separate;
}
.orgchart > table:first-child {
  margin: 20px auto;
}
.orgchart td {
  text-align: center;
  vertical-align: top;
  padding: 0;
}
.orgchart .lines:nth-child(3) td {
  box-sizing: border-box;
  height: 20px;
}
.orgchart .lines .topLine {
  border-top: 2px solid #999999;
}
.orgchart .lines .rightLine {
  border-right: 1px solid #999999;
  float: none;
  border-radius: 0;
}
.orgchart .lines .leftLine {
  border-left: 1px solid #999999;
  float: none;
  border-radius: 0;
}
.orgchart .lines .downLine {
  background-color: #999999;
  margin: 0 auto;
  height: 20px;
  width: 2px;
  float: none;
}
/* node styling */
.orgchart .node {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 3px;
  border: 2px dashed transparent;
  text-align: center;
  width: auto !important;
}
.orgchart.l2r .node,
.orgchart.r2l .node {
  width: 50px;
  height: 130px;
}
.orgchart .node > .spinner {
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  vertical-align: middle;
  font-size: 30px;
  color: rgba(68, 157, 68, 0.8);
}
.orgchart .node:hover {
  /* background-color: rgba(238, 217, 54, 0.5); */
  background-color: transparent !important;
  transition: 0.5s;
  cursor: default;
  z-index: 20;
}
.orgchart .node.focused {
  /* background-color: rgba(238, 217, 54, 0.5); */
  background-color: transparent !important;
}
.orgchart .ghost-node {
  position: fixed;
  left: -10000px;
  top: -10000px;
}
.orgchart .ghost-node rect {
  fill: #ffffff;
  stroke: #bf0000;
}
.orgchart .node.allowedDrop {
  border-color: rgba(68, 157, 68, 0.9);
}
.orgchart .node .title {
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: #999999;
  color: #fff;
  border-radius: 4px 4px 0 0;
}
.orgchart.b2t .node .title {
  transform: rotate(-180deg);
  transform-origin: center bottom;
}
.orgchart.l2r .node .title {
  transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
  transform-origin: bottom center;
  width: 120px;
}
.orgchart.r2l .node .title {
  transform: rotate(-90deg) translate(-40px, -40px);
  transform-origin: bottom center;
  width: 120px;
}
.orgchart .node .title .symbol {
  float: left;
  margin-top: 4px;
  margin-left: 2px;
}
.orgchart .node .content {
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  font-size: 11px;
  line-height: 18px;
  border: 1px solid #999999;
  border-radius: 0 0 4px 4px;
  text-align: center;
  background-color: #fff;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.orgchart.b2t .node .content {
  transform: rotate(180deg);
  transform-origin: center top;
}
.orgchart.l2r .node .content {
  transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
  transform-origin: top center;
  width: 120px;
}
.orgchart.r2l .node .content {
  transform: rotate(-90deg) translate(-40px, -40px);
  transform-origin: top center;
  width: 120px;
}
.orgchart .node .edge {
  font-size: 15px;
  position: absolute;
  color: rgba(68, 157, 68, 0.5);
  cursor: default;
  transition: 0.2s;
}
.orgchart.noncollapsable .node .edge {
  display: none;
}
.orgchart .edge:hover {
  color: #449d44;
  cursor: pointer;
}
.orgchart .node .verticalEdge {
  width: calc(100% - 10px);
  width: -webkit-calc(100% - 10px);
  width: -moz-calc(100% - 10px);
  left: 5px;
}
.orgchart .node .topEdge {
  top: -4px;
}
.orgchart .node .bottomEdge {
  bottom: -4px;
}
.orgchart .node .horizontalEdge {
  width: 15px;
  height: calc(100% - 10px);
  height: -webkit-calc(100% - 10px);
  height: -moz-calc(100% - 10px);
  top: 5px;
}
.orgchart .node .rightEdge {
  right: -4px;
}
.orgchart .node .leftEdge {
  left: -4px;
}
.orgchart .node .horizontalEdge::before {
  position: absolute;
  top: calc(50% - 7px);
}
.orgchart .node .rightEdge::before {
  right: 3px;
}
.orgchart .node .leftEdge::before {
  left: 3px;
}
.orgchart .node .toggleBtn {
  position: absolute;
  left: 5px;
  bottom: -2px;
  color: rgba(68, 157, 68, 0.6);
}
.orgchart .node .toggleBtn:hover {
  color: rgba(68, 157, 68, 0.8);
}
.oc-export-btn {
  width: 76px;
  height: 34px;
  padding-top: -20px;
  top: 0px;
/* //   display: inline-block; */
  position: absolute;
}

.orgchart ~ .mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.orgchart ~ .mask .spinner {
  position: absolute;
  top: calc(50% - 54px);
  left: calc(50% - 54px);
  color: rgba(255, 255, 255, 0.8);
  font-size: 108px;
}
.orgchart .node {
  transition: transform 0.3s, opacity 0.3s;
}
.orgchart .slide-down {
  opacity: 0;
  transform: translateY(40px);
}
.orgchart.l2r .node.slide-down,
.orgchart.r2l .node.slide-down {
  transform: translateY(130px);
}
.orgchart .slide-up {
  opacity: 0;
  transform: translateY(-40px);
}
.orgchart.l2r .node.slide-up,
.orgchart.r2l .node.slide-up {
  transform: translateY(-130px);
}
.orgchart .slide-right {
  opacity: 0;
  transform: translateX(130px);
}
.orgchart.l2r .node.slide-right,
.orgchart.r2l .node.slide-right {
  transform: translateX(40px);
}
.orgchart .slide-left {
  opacity: 0;
  transform: translateX(-130px);
}
.orgchart.l2r .node.slide-left,
.orgchart.r2l .node.slide-left {
  transform: translateX(-40px);
}
</style>
